export const bar = {
    label: {
        visible: !1,
        position: "outside",
        offset: 5,
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    }
};
//# sourceMappingURL=bar.js.map
